import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import InternalServerError from "../pages/general/internal-server-error/internal-server-error";
import ResourceNotFound from "../pages/general/resource-not-found/resource-not-found";
import FAQ from "../pages/general/faq/faq";
import { IdentityContext } from "../context/identity-context";

const Content = ({ modules, role }) => {
    const { defaultPath } = useContext(IdentityContext);

    return (
        <Container fluid="xl">
            <Routes>
                {modules.map((route, i) => {
                    const Component = route.component;
                    return <Route key={i} path={`${route.path}/*`} element={<Component />} />;
                })}
                <Route path="/resource-not-found" element={<ResourceNotFound />} />
                <Route path="/internal-server-error" element={<InternalServerError />} />
                <Route path="/faq" element={<FAQ role={role} />} />
                {defaultPath && <Route path="*" element={<Navigate to={defaultPath} replace />} />}
            </Routes>
        </Container>
    );
};

export default Content;
